import { controller, target, targets } from "@github/catalyst"

// Checklist for packing. `boxes` are required (every one must be ticked);
// `optionalBoxes` belong to groups (data-group) that must be ticked all or
// none — e.g. a VIP claim riding along in a Shopify box. The submit button
// stays disabled until both hold. Progress text comes from
// data-progress-template ("%{done} of %{total} packed").
@controller
class PackingListElement extends HTMLElement {
  @targets boxes!: HTMLInputElement[]
  @targets optionalBoxes!: HTMLInputElement[]
  @target submit!: HTMLButtonElement
  @target progress!: HTMLElement

  connectedCallback() {
    this.update()
  }

  update() {
    const done = this.boxes.filter((box) => box.checked).length
    const total = this.boxes.length
    this.submit.disabled = done < total || !this.groupsConsistent()
    const template = this.progress.getAttribute("data-progress-template") || ""
    this.progress.textContent = template.replace("%{done}", String(done)).replace("%{total}", String(total))
  }

  private groupsConsistent(): boolean {
    const groups = new Map<string, HTMLInputElement[]>()
    for (const box of this.optionalBoxes) {
      const key = box.getAttribute("data-group") || ""
      groups.set(key, [...(groups.get(key) || []), box])
    }
    for (const members of groups.values()) {
      const checked = members.filter((box) => box.checked).length
      if (checked > 0 && checked < members.length) return false
    }
    return true
  }
}

export default PackingListElement
